export enum WidgetNameDisplay{
    Long = 'fullName',
    Short = 'shortName'  
}